<template>
  <!--查看-->
  <div>
    <el-form :model="formData" :rules="rules" v-loading="saveLoading" ref="integrateAddForm" size="mini" :label-width="'150px'" class="form-horizontal detail-form paddingTopDetail roomEditDetail" >
      <el-form-item prop="fybm" class="is-required" label="房源编码：" >
        {{formData.fybm}}
      </el-form-item>
      <el-form-item prop="fymc" class="is-required" label="房源名称：" >
        {{formData.fymc}}
      </el-form-item>
      <el-form-item prop="msbm" class="is-required" label="门锁编码：" >
        <el-input v-model="formData.msbm" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item prop="fjh" class="is-required" label="房间号：" >
        <el-input v-model="formData.fjh" placeholder="请输入" ></el-input>
      </el-form-item>
      <!-- <el-form-item prop="sbxh" class="is-required" label="设备型号：" >
        <el-input v-model="formData.sbxh" placeholder="请输入" ></el-input>
      </el-form-item>
      <el-form-item prop="sbmc" class="is-required" label="门锁名称：" >
        <el-input v-model="formData.sbmc" placeholder="请输入" ></el-input>
      </el-form-item> -->
      <div style="text-align: center;padding: 20px;width: 100%;">
        <el-button class="primary-btn-g" icon="CircleCheck" @click="handleSave(0)" >确认绑定</el-button>
        <el-button class="warning-btn-g" icon="CircleClose" @click="handleCancel">关闭</el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
  import Vue from 'vue';
  import RichText from "@/components/common/RichText/RichText";
  import {
    mapActions
  } from 'vuex'
  import moment from 'moment'
  export default {
    components: {RichText},
    name: "publishDetailModel",
      props:{
        selOptions: {
          type: Object,
          default:{czlx:[],fwly:[],cqrGjdm:[],cqrCyzjdm:[],jyzbm:[]},
        },
        detailModal:{
          type:Boolean,
          default:''
        },
        detailData:{
          type:Object,
          default:{}
        },
        detailType:{
          type:String,
          default:'show'
        }
      },
      data(){
        let detailKeys = ['fybm','fymc','msbm','fjh' ]
        let formData = {}
        detailKeys.map((key)=>{
          formData[key] = ''
        })
        return{
          isValid:true,
          showType:'',
          saveLoading:false,
          detailKeys:detailKeys,
          uploadUrl:'',
          fileList:[],
          rules:{
            // fybm: [{ required: true, message: '请输入', trigger: 'blur' },],
            msbm: [{ required: true, message: '请输入', trigger: 'blur' },],
            fjh: [{ required: true, message: '请输入', trigger: 'blur' },],
            // sbxh: [{ required: true, message: '请输入', trigger: 'blur' },],
          },
          wyfdzSsxqdm_provinceDicts:[],
          wyfdzSsxqdm_cityDicts:[],
          wyfdzSsxqdm_areaDicts:[],
          wyfdzSsxqdm_policeDicts:[],
          areaCodes:{},
          formData:formData
        }
    },
    created(){
      this.uploadUrl =  location.origin + '/saas/api/web/fileStorage/upload'
      this.initSelData()
    },
    mounted(){
      this.showType = this.detailType
    },
    watch:{
      detailType(val){
        this.showType = val
      },
      detailModal:{
        immediate: true,
        handler: function(to){
          if(to===false){
            return false
          }
          console.log(this.detailData,'-----')
          this.detailKeys.map((key)=>{
            this.formData[key] = ''
          })
          this.formData.fybm = this.detailData.wyfbm
          this.formData.fymc = this.detailData.wyfmc
        }
      }
    },
    methods:{
      ...mapActions([
        'alertToggle',
        'fetchData'
      ]),
      //上传图片

      handleUploadRemove(file, fileList){
        this.formData.zp = ''
      },
      handleUploadSuccess(response, file, fileList){
        this.formData.zp = response.body.fileList[0].url
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeAvatarUpload(file) {
        const isLtM = file.size / 1024 / 1024 < 10;

        if (!isLtM) {
          this.$message.error('上传附件大小不能超过 10MB!');
        }
        return isLtM ;
      },
      //选择经纬度
      handleOpenModal(type) {
        this.$refs.mapDialog.show()
        if (this.regionModalType !== type) {
          this.$refs.mapDialog.reset()
        }
        this.regionModalType = type
        //$('#regionModal').modal('show')
      },
      //初始化列表数据
      initSelData() {
        //区域
        let sp1 = this.fetchData({
          url: 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE',
          params: {
            areaCode: '0'
          },
          method: 'get'
        })
        Promise.all([sp1]).then(([rest1]) => {
          this.$nextTick(()=> {
            let tempArr = []
            rest1 && rest1.data.forEach(re => {
              if (re.areaName) {
                tempArr.push({
                  value: re.areaCode,
                  label: re.areaName,
                  areaCode: re.areaCode,
                  areaName: re.areaName
                })
              }
            })
            this['wyfdzSsxqdm_provinceDicts'] = [...tempArr]
          })

        }).catch((err)=>{
          console.log(err,'-----------')
        }).finally(()=>{
          this.$nextTick(()=>{
            this.saveLoading = false
          })
        })
      },
      handleAreaChange(res,evt,flag){
        let tempArr = []
        res.data.forEach(re => {
          if (re.areaName) {
            tempArr.push({
              value: re.areaCode,
              label: re.areaName,
              areaCode: re.areaCode,
              areaName: re.areaName,
            })
          }
          if (re.name) {
            tempArr.push({
              value: re.policeCode,
              label: re.name,
            })
          }
        });
        if (evt === 'getCity') {
          this.wyfdzSsxqdm_cityDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.dwbgdzSbm = '';
          this.formData.dwbgdzQbm = '';
          this.formData.dwbgdzSsxq = '';
        }
        if (evt === 'getArea') {
          this.wyfdzSsxqdm_areaDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.dwbgdzQbm = '';
          this.formData.dwbgdzSsxq = '';
        }
        if (evt === 'getPoliceStation') {
          this.wyfdzSsxqdm_policeDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.dwbgdzSsxq = '';
        }
      },
      selectedChange(code, evt ,flag = false) {
        let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
        if (evt === 'getPoliceStation') {
          url = 'COMBOBOX.FIND_POLICE_STATION_LIST_BY_AREA_CODE'
        }
        /*let code = codeValue.substr(-6)*/
        let params = { areaCode: code }
        this.fetchData({
          url,
          method: 'get',
          params
        }).then(res => {
          let tempArr = []
          res.data.forEach(re => {
            if (re.areaName) {
              tempArr.push({
                value: re.areaCode,
                label: re.areaName,
                areaCode: re.areaCode,
                areaName: re.areaName,
              })
            }
            if (re.name) {
              tempArr.push({
                value: re.policeCode,
                label: re.name,
              })
            }

          });
          if (evt === 'getCity') {
            this.wyfdzSsxqdm_cityDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.dwbgdzSbm = '';
            this.formData.dwbgdzQbm = '';
            this.formData.dwbgdzSsxq = '';
          }
          if (evt === 'getArea') {
            this.wyfdzSsxqdm_areaDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.dwbgdzQbm = '';
            this.formData.dwbgdzSsxq = '';
          }
          if (evt === 'getPoliceStation') {
            this.wyfdzSsxqdm_policeDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.dwbgdzSsxq = '';
          }
        }).catch(err => {
          this.error = err
        })
      },
      handleMapSaveData(obj){
        this.formData.bddtjd_bddtwd = obj.lng+','+obj.lat
        this.formData.bddtjd = obj.lng
        this.formData.bddtwd = obj.lat
        let addComp = obj.addComp
        this.formData.wyfdzQhnxxdz = addComp.province+" "+addComp.city+" "+addComp.district+" "+addComp.street+" "+addComp.streetNumber
      },
      //保存与发布
      handleSave(type){
        this.saveLoading = true
        this.$refs['integrateAddForm'].validate((valid) => {
          if (valid && this.isValid) {
            this.doSave(type)
          } else {
           // this.$message.error('输入不合法！')
            this.saveLoading = false
            return false;
          }
        });
      },
      doSave(type){


        let url = 'SAAS.DOORLOCK_UPDATE'
        let paramData = {...this.formData}
        paramData.sbcszzjgdm = '91440300359916197H'
        paramData.sblx = '103'
        paramData.azsj = moment().format('YYYY-MM-DD HH:mm:ss')
        paramData.gxsj =  moment().format('YYYY-MM-DD HH:mm:ss')

        let params = {params:JSON.stringify(paramData)}

        this.fetchData({url:url, method: 'post', params:params,timeout:0, isLoading:false, flag:true}).then((res)=>{
          if(res.status==1){
            this.$message.success('操作成功！')
            this.$emit('submitSuccess')
          }else{
            this.$message.error(res.msg||'操作失败！')
          }
          this.saveLoading = false
        }).catch((err)=>{
          this.$message.error(err || '操作失败！')
          this.saveLoading = false
        }).finally (()=>{
          this.saveLoading = false
        })
      },
      handleCancel(){
        this.$emit('closeModel')
      },
    },
  }
</script>

<style lang="less" scoped>
  .roomEditDetail{
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 90% !important;
  }
  .roomEditDetail .el-form-item{
    width: 50% !important;
    .el-select{
      width: 100%;
    }
  }
  .el-collapse{
    width: 100%;
  }
  .roomEditDetail .el-form-item.rowItem {
    width: 100% !important;
  }
  .roomEditDetail .detailContent{
    padding: 0px;
  }
  .sentContent{
    margin: 20px;
    padding: 10px;
    border: 1px solid rgba(38, 118, 165, 1) ;
  }
  .sentContentTitle{
    text-align: center;
  }


</style>
<style lang="less" >
  .roomEditDetail .w-e-text-container{
    border:1px solid #2676a5 !important;
  }
</style>

